// files and use index as a collector import/export etc
export const APP_NODE_NAMESPACE = '___REACT_APP_NAMESPACE_GREBBAN__';
export const EMOTION_IDS_KEY = '__EMOTION_IDS__';
export const INITIAL_STATE_KEY = '__INITIAL_STATE__';
export const INITIAL_PROMISES_CONTEXT = '__INITIAL_PROMISES_CONTEXT__';
export const MOBILE_KEY = 'isMobile';
export const SITE_DATA_CACHE_EXPIRATION = 60 * 1000; // 1 minute
export const POST_DATA_CACHE_EXPIRATION = 60 * 1000; // 1 minute
export const BRAND_COUNT_CACHE_EXPIRATION = 60 * 60 * 1000; // 1 hour
export const RESOLVE_URL_DATA_CACHE_EXPIRATION = 60 * 1000; // 1 minute
export const API_ENDPOINT = '/api/v1';

// Boolean to tell if we're in production-environment or not.
export const inProduction = process.env.NODE_ENV === 'production';
// Boolean to tell if we should build for SSR
export const inServer = process.env.BUILD_TARGET === 'server';

export const inBrowser = typeof window !== 'undefined';

export const isSupportingLazy = typeof HTMLImageElement !== 'undefined' && 'loading' in HTMLImageElement.prototype;

export const API_URL =
    (inServer && process.env.REACT_APP_GREBBCOMMERCE_API_URL_SSR) || process.env.REACT_APP_GREBBCOMMERCE_API_URL;

/** Sanity CDN image srcSet widths; Use with generateSanityImageSrcSet. */
export const SANITY_IMAGE_SRCSET_WIDTHS = [320, 400, 500, 650, 800, 960, 1280, 1440, 1600, 1920, 2560, 3840] as const;

/** Width (px) for LQIP / lazy load placeholder. */
export const SANITY_IMAGE_PLACEHOLDER_WIDTH = 25;

/** Max width (px) for background video poster (fallback while loading). Keeps size reasonable. */
export const SANITY_VIDEO_BACKGROUND_POSTER_WIDTH = 1440;
